module.exports = __webpack_public_path__ + "static/media/Item_Weapon_M16A4_C.98cfdc32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_M16A4_C.png
// module id = 226
// module chunks = 0